<template>
  <div class="background">
    <section class="main-container">
      <aside class="branding">
        <img src="/assets/logo.png" alt="logo" class="logo" />
        <h2 class="title">LocusVMS</h2>
        <p class="description short">Venue Management System</p>
        <p class="description long">
          A powerful, yet easy-to-use application for managing venue geospatial
          data.
        </p>
      </aside>
      <section class="form-container">
        <h3 class="form-title">Reset Password</h3>
        <form @submit.prevent="onSubmit">
          <div class="form-group">
            <label for="reset-code">Reset Code</label>
            <input
              id="reset-code"
              type="text"
              class="input-field"
              v-model="resetCode"
            />
          </div>
          <div class="form-group">
            <label for="new-password">New Password</label>
            <input
              id="new-password"
              type="password"
              class="input-field"
              v-model="newPassword"
            />
          </div>
          <button type="submit" class="submit-button" :disabled="loading">
            <div v-if="loading" class="loading-spinner"></div>
            <span v-else>Submit</span>
          </button>
          <div v-if="showError" class="error">
            {{ errmsg }}
          </div>
        </form>
        <div class="divider"></div>
      </section>
    </section>
  </div>
</template>

<script>
  import { router } from "@/router/index";
  import * as config from "@/config";
  const AmazonCognitoIdentity = require("amazon-cognito-identity-js");

  export default {
    name: "ResetPassword",
    data() {
      return {
        loading: false,
        resetCode: "",
        newPassword: "",
        showError: false,
        errmsg: "",
      };
    },
    methods: {
      onSubmit() {
        const userPool = new AmazonCognitoIdentity.CognitoUserPool(
          config.poolData
        );
        const username = this.$store.state.username;

        if (!username) {
          this.showError = true;
          this.errmsg = "Username does not exist. Please try again.";
          return;
        }

        const userData = {
          Username: username,
          Pool: userPool,
        };

        const cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
        this.showError = false;
        this.errmsg = "";
        this.loading = true;

        cognitoUser.confirmPassword(this.resetCode, this.newPassword, {
          onSuccess: (data) => {
            this.loading = false;
            console.log("Password reset confirmed:", data);
            router.push("/sign-in");
          },
          onFailure: (err) => {
            this.loading = false;
            this.showError = true;
            this.errmsg = this.getErrorMessage(err.code);
            console.error("Password reset error:", err);
          },
        });
      },
      getErrorMessage(code) {
        switch (code) {
          case "CodeMismatchException":
            return "Invalid verification code provided";
          case "NotAuthorizedException":
            return "The user has already been confirmed";
          case "UserNotFoundException":
            return "Username (email) not found!";
          case "LimitExceededException":
            return "Attempt limit exceeded, please try again later";
          case "UserNotConfirmedException":
            return "User registration not confirmed";
          default:
            return "An error has occurred!";
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "@/styles/pages/auth/reset-password.scss";
</style>
